import React from 'react'
import styled from '@emotion/styled'
import { font } from '@mobi/component-library/Foundations'

type PlayerJerseyIconProps = {
  url: string
  number: string
  numberColor?: string | null
}

export const PlayerJerseyIcon = ({ url, number, numberColor }: PlayerJerseyIconProps) => {
  return (
    <PlayerJerseyIconStyled>
      <img src={url} alt='' />

      <span style={{ color: numberColor ?? undefined }}>{number}</span>
    </PlayerJerseyIconStyled>
  )
}

// ======
// Styles
// ======

const PlayerJerseyIconStyled = styled.span({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '2rem',
  height: '2rem',

  img: {
    width: '100%',
    height: '100%',
    display: 'block',
  },

  span: {
    position: 'absolute',
    fontSize: font.size.sm.fontSize,
    fontWeight: font.weight.bold,
    lineHeight: 1,
  },
})
